import { render, staticRenderFns } from "./VTabBody.vue?vue&type=template&id=075da124&scoped=true&"
import script from "./VTabBody.vue?vue&type=script&lang=js&"
export * from "./VTabBody.vue?vue&type=script&lang=js&"
import style0 from "./VTabBody.vue?vue&type=style&index=0&id=075da124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075da124",
  null
  
)

export default component.exports